import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { GTM } from '@app/gtm';
import { getDossierSelector } from '@model/Candidate/Candidate.selectors';
import { jobCompanyNameSelector } from '@model/Job/Job.selectors';
import { GTM_EVENT_ACTION_DOSSIER } from '@utils/hooks/use-download-dossier/_constants/use-download-dossier.constants';
import type { TUseDownloadDossierReturn } from '@utils/hooks/use-download-dossier/use-download-dossier.types';

export const useDownloadDossier = (): TUseDownloadDossierReturn => {
  const { candidateId, jobId } = useParams<{
    candidateId: string;
    jobId: string;
  }>();

  const companyName = useStoreState(jobCompanyNameSelector);
  const getDossier = useStoreActions(getDossierSelector);

  return useCallback(async () => {
    if (!candidateId || !jobId) {
      return null;
    }

    const eventLabel = `${jobId} - ${candidateId} - download`;

    try {
      return await getDossier({ candidateId, jobId });
    } finally {
      GTM.trackGTMEvent({
        action: GTM_EVENT_ACTION_DOSSIER,
        label: eventLabel,
      });

      GTM.trackGA4Event(GTM_EVENT_ACTION_DOSSIER, companyName, eventLabel);
    }
  }, [candidateId, companyName, getDossier, jobId]);
};
